/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const DownloadSolidV6 = (props) => (
  <Icon {...props} name="Download Solid V6">
    <path d="M15 11h-4.172l-1.414 1.414C9.037 12.791 8.534 13 8 13s-1.036-.208-1.414-.586L5.172 11H1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm-1.5 3.25c-.412 0-.75-.338-.75-.75s.338-.75.75-.75.75.338.75.75-.338.75-.75.75zm-6.206-2.544a.997.997 0 0 0 1.413.001l4-4a1 1 0 0 0-1.414-1.414L9 8.588V1.001a1 1 0 0 0-2 0v7.587L4.706 6.294a.999.999 0 1 0-1.414 1.414l4.002 3.998z" />
  </Icon>
);

export default DownloadSolidV6;
